import axios from 'axios';
import buildQuery from 'odata-query';

import { IRequestConfig, MethodsTypes } from 'models/Axios';
import { IDomainSetting } from 'models/DomainSetting';
import { IUser, UserType } from 'models/User';
import { UserFilter } from 'models/UserFilter';
import Services from './index.service';

export default class GroupUserService extends Services<any, IUser> {
  private base = () => this.mafraq_url;

  private auth = () => ({
    Authorization: `Bearer ${this.access_token()}`,
  });

  public filter = (
    currentPage?: number,
    pageSize?: number,
    filter?: UserFilter,
    ordination?: { field: number; direction: number }
  ) => {
    const config: IRequestConfig<IUser> = {
      baseUrl: this.base(),
      url: '/users/filter',
      params: {
        search: filter?.search,
        userType: filter?.userType,
        profileType: filter?.profileType,
        deleted: filter?.deleted ?? false,
        enabled: filter?.enabled,
        pageSize: pageSize || 20,
        pageNumber: currentPage || 0,
        sortField: ordination?.field,
        sortDirection: ordination?.direction,
      },
    };

    return this.httpRequest(config);
  };

  public getProfiles = () => {
    const filterQuery = buildQuery({
      filter: {
        and: [
          { identifier: { eq: 'UserProfileTypes' } },
          { key: { ne: 'CUSTOMER' } },
          { enabled: { eq: true } },
        ],
      },
    });

    const config: IRequestConfig<IDomainSetting> = {
      baseUrl: this.base(),
      url: `/domain-settings${filterQuery}`,
      params: {
        $top: '50',
        $skip: '0',
        $orderby: 'value asc',
      },
    };

    return this.httpRequest(config);
  };

  public async saveEmployee(user: IUser) {
    const data = {
      id: user.id,
      fullName: user.fullName,
      email: user.email,
      username: user.username,
      roles: user.roles,
      profileType: user.profileType,
      sellerId: user.sellerId,
      managerId: user.managerId,
      userType: user.userType ?? UserType.Employee,
      enabled: user.enabled ?? true,
      deleted: user.deleted ?? false,
    };

    const url = data.id
      ? `${this.base()}/users/alter_employee`
      : `${this.base()}/users/register_employee`;
    const request = data.id ? axios.put : axios.post;

    return request(url, data, { headers: this.auth() })
      .then((result) => result)
      .catch((err) => err);
  }

  public async keycloakFind(userName: string) {
    const config: IRequestConfig<any> = {
      url: `${this.base()}/users/keycloak/find`,
      method: MethodsTypes.get,
      headers: this.auth(),
      params: { userName },
    };

    return axios(config)
      .then((result) => result)
      .catch(() => ({ data: [] }));
  }

  public async autoComplete(sentence: string, userType: UserType = UserType.Employee) {
    const config: IRequestConfig<any> = {
      url: `${this.base()}/users/autocomplete?sentence=${encodeURIComponent(`"${sentence}"`)}&userType=${userType}`,
      method: MethodsTypes.get,
      headers: this.auth(),
    };

    return axios(config)
      .then((result) => result.data)
      .catch(() => []);
  }

  public async sellerAutoComplete(sentence: string) {
    const config: IRequestConfig<any> = {
      url: `${this.base()}/Seller/autocomplete`,
      method: MethodsTypes.get,
      headers: this.auth(),
      params: { sentence },
    };

    return axios(config)
      .then((result) => result.data)
      .catch(() => ({ data: [] }));
  }
}
